const routines = [
  {
    period: "AM",
    title: "Morning Defence",
    note: "A bright, lightweight ritual made for heat, humidity, and city exposure.",
    image:
      "https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=900&q=80",
    timing: "7:00 - 10:00 AM",
    finish: "Fresh matte glow",
    steps: [
      {
        name: "Neem Gel Cleanse",
        detail: "Lift sweat and overnight oil without stripping the barrier.",
      },
      {
        name: "Kesar Glow Serum",
        detail: "Layer brightening botanicals before moisture.",
      },
      {
        name: "Barrier Moisturizer",
        detail: "Seal hydration with a comfortable, non-heavy finish.",
      },
      {
        name: "Matte SPF 50",
        detail: "Protect against UV, pollution, and daytime dullness.",
      },
    ],
  },
  {
    period: "PM",
    title: "Night Repair",
    note: "A slower evening ritual for calm skin, recovery, and a nourished finish.",
    image:
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&w=900&q=80",
    timing: "Before sleep",
    finish: "Soft rested skin",
    steps: [
      {
        name: "Gentle Double Cleanse",
        detail: "Remove sunscreen, grime, and buildup from the day.",
      },
      {
        name: "Repair Serum",
        detail: "Support texture, tone, and barrier comfort overnight.",
      },
      {
        name: "Haldi Chandan Cream",
        detail: "Bring a soothing ritual finish with traditional botanicals.",
      },
      {
        name: "Slow Facial Massage",
        detail: "Press product in and relax tension for two minutes.",
      },
    ],
  },
];

const RoutineGuide = () => {
  return (
    <section className="routine-section premium-routine-section">
      <div className="section-container">
        <div className="section-heading split premium-routine-heading">
          <div>
            <p>Daily ritual</p>
            <h2>Skin Routine Guide</h2>
          </div>
          <span>
            Curated AM and PM rituals with clean actives, Ayurvedic botanicals,
            and a finish that suits Indian weather.
          </span>
        </div>

        <div className="premium-routine-grid">
          {routines.map((routine) => (
            <article className="premium-routine-card" key={routine.title}>
              <div className="premium-routine-media">
                <img src={routine.image} alt={`${routine.title} skincare`} />
                <span>{routine.period}</span>
              </div>

              <div className="premium-routine-copy">
                <div className="premium-routine-topline">
                  <span>{routine.timing}</span>
                  <strong>{routine.finish}</strong>
                </div>

                <h3>{routine.title}</h3>
                <p>{routine.note}</p>

                <div className="premium-routine-steps">
                  {routine.steps.map((step, index) => (
                    <div className="premium-routine-step" key={step.name}>
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <div>
                        <h4>{step.name}</h4>
                        <p>{step.detail}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoutineGuide;
